package com.upcominds.expedite.dto

import kotlinx.serialization.Serializable

@Serializable
data class ApiError(
    val message: String
)
